import { Dispatch, SetStateAction } from 'react';
import { GameState } from '../../domain/entities';
import { useTacticsManagement } from './management/useTacticsManagement';
import { useTrainingManagement } from './management/useTrainingManagement';
import { usePlayerManagement } from './management/usePlayerManagement';
import { useTransferManagement } from './management/useTransferManagement';
import { useYouthAcademyManagement } from './management/useYouthAcademyManagement';
import { useManagerManagement } from './management/useManagerManagement';

type SetGameState = Dispatch<SetStateAction<GameState | { gameStarted: false; }>>;

interface UseClubManagementProps {
    gameState: GameState | { gameStarted: false };
    setGameState: SetGameState;
}

export const useClubManagement = ({ gameState, setGameState }: UseClubManagementProps) => {
    const tacticsManagement = useTacticsManagement({ setGameState });
    const trainingManagement = useTrainingManagement({ setGameState });
    const playerManagement = usePlayerManagement({ setGameState });
    const transferManagement = useTransferManagement({ gameState, setGameState });
    const youthAcademyManagement = useYouthAcademyManagement({ setGameState });
    const managerManagement = useManagerManagement({ setGameState });

    return {
        ...tacticsManagement,
        ...trainingManagement,
        ...playerManagement,
        ...transferManagement,
        ...youthAcademyManagement,
        ...managerManagement,
    };
};
